import api from "@/lib/api";

let cache = null;

export async function loadLikes() {
  try {
    const { data } = await api.get("/music/favorites/ids");
    cache = new Set(data.ids);
  } catch (e) { cache = new Set(); }
  window.dispatchEvent(new Event("likes-changed"));
  return cache;
}

export function isLiked(id) {
  return cache ? cache.has(id) : false;
}

export async function toggleLike(id) {
  if (!cache) await loadLikes();
  if (cache.has(id)) {
    cache.delete(id);
    window.dispatchEvent(new Event("likes-changed"));
    api.delete(`/music/favorites/${id}`).catch(() => {});
    return false;
  }
  cache.add(id);
  window.dispatchEvent(new Event("likes-changed"));
  api.post("/music/favorites", { track_id: id }).catch(() => {});
  return true;
}
